import { createAction } from 'redux-act';

export class PagesActions {
  public static selectPage = createAction<number>();
}
